import React from "react"

import { useApiContextSlug } from "~/api"
import { CaseType } from "~/api/types/Case"
import {
  HeadingLink,
  HeadingTitle,
  HeadingWithLink,
} from "~/components/HeadingWithLink/HeadingWithLink"

import { Raw } from "../raw"
import { Case } from "./components/Case/Case"
import styles from "./index.module.css"

type Props = {
  title: string
  linkName: string
  items: CaseType[]
}

export const Cases: React.FC<Props> = ({ title, linkName, items }) => {
  const slug = useApiContextSlug()

  if (!items || items.length === 0) {
    return null
  }

  return (
    <div className={styles.Wrapper}>
      <div className="container">
        <HeadingWithLink>
          <HeadingTitle>
            <Raw html={title} />
          </HeadingTitle>

          <HeadingLink href={`/${slug}/cases`}>
            <Raw html={linkName} />
          </HeadingLink>
        </HeadingWithLink>

        <div className={styles.Projects}>
          {items.slice(0, 2).map((item) => (
            <Case key={item.id} {...item} />
          ))}
        </div>
      </div>
    </div>
  )
}
